import { NgModule } from '@angular/core';
import { SanitizedHtmlPipe } from './santized-html.pipe';
import { RemoveDefaultPipe } from './remove-default.pipe';
import { CommonModule } from '@node_modules/@angular/common';
import { AblePipe } from './acl/able.pipe';
import { SecondsToTimePipe } from './seconds-to-time.pipe';
import { SanitizedUrlPipe } from './santized-url.pipe';
import { LinkPipe } from './link.pipe';
import { MentionsPipe } from './mentions.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { PhoneFormatPipe } from './phone-format.pipe';
import { TimeFormatPipe } from './time-format.pipe';
import { TimeDiffFormatPipe } from './time-diff-format.pipe';
import { TimerPipe } from './timer.pipe';
import { ScheduledTimePipe } from './scheduled-time.pipe';
import { DateRangePipe } from './date-range.pipe';
import { MaskPhonePipeRuleset } from './mask-phone-ruleset.other.pipe';
import { FormErrorPipe } from './form-error.pipe';
import { MarkdownPipe } from './markdown.pipe';
import { AgentMentionFormatPipe } from './agent-mention-format.pipe';
import { DocumentFormatPipe } from './document-format.pipe';
import { BrPhoneFormatPipe } from './br-phone-format.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    SafeHtmlPipe,
    MarkdownPipe,
    SanitizedHtmlPipe,
    RemoveDefaultPipe,
    AblePipe,
    SecondsToTimePipe,
    SanitizedUrlPipe,
    LinkPipe,
    MentionsPipe,
    MaskPhonePipeRuleset,
    TimeFormatPipe,
    TimeDiffFormatPipe,
    TimerPipe,
    PhoneFormatPipe,
    ScheduledTimePipe,
    DateRangePipe,
    FormErrorPipe,
    AgentMentionFormatPipe,
    DocumentFormatPipe,
    BrPhoneFormatPipe,
  ],
  exports: [
    MarkdownPipe,
    SafeHtmlPipe,
    SanitizedHtmlPipe,
    RemoveDefaultPipe,
    AblePipe,
    SecondsToTimePipe,
    SanitizedUrlPipe,
    LinkPipe,
    MentionsPipe,
    MaskPhonePipeRuleset,
    TimeFormatPipe,
    TimeDiffFormatPipe,
    TimerPipe,
    PhoneFormatPipe,
    ScheduledTimePipe,
    DateRangePipe,
    FormErrorPipe,
    AgentMentionFormatPipe,
    DocumentFormatPipe,
    BrPhoneFormatPipe,
  ],
})
export class PipesModule {}
